export { default } from "./globalState";
